import { render, staticRenderFns } from "./right-bar.vue?vue&type=template&id=1f854836&scoped=true&"
import script from "./right-bar.vue?vue&type=script&lang=js&"
export * from "./right-bar.vue?vue&type=script&lang=js&"
import style1 from "./right-bar.vue?vue&type=style&index=1&id=1f854836&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f854836",
  null
  
)

export default component.exports